/**
 * Pre-compiled de messages for DataTable
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  comfortable: `Komfortabel`,
  comfortableAriaLabel: `Komfortabler Bereich`,
  compact: `Kompakt`,
  compactAriaLabel: `Kompakter Bereich`,
  dataTable: `Datentabelle`,
  dataTableBody: `Datentabellenkörper`,
  dataTableHeader: `Datentabellenüberschrift`,
  expandRows: `Zeilen erweitern`,
  fullText: `Vollständiger Text`,
  fullTextAriaLabel: `Volltextbereich`,
  hiddenColumns: `Ausgeblendete Spalten`,
  hiddenColumnsAriaLabel: `Ausgeblendete Spaltenliste`,
  hideColumn: `Spalte ausblenden`,
  layoutSettings: `Layout-Einstellungen`,
  layoutSettingsAriaLabel: `Bereich Layout-Einstellungen`,
  noHiddenColumns: `Keine ausgeblendeten Spalten`,
  pinRows: `Zeilen fixieren`,
  reset: `Spalten zurücksetzen`,
  resizeColumn: `Spalte vergrößern`,
  rowDensity: `Zeilendichte`,
  rowDensityAriaLabel: `Abschnitt Zellendichte`,
  searchHiddenColumns: `Suche ...`,
  selectRow: `Zeile auswählen`,
  settings: `Tabellen-Einstellungen`,
  settingsTabsAriaLabel: `Einstellungen-Registerkarten`,
  textPreviews: `Textvorschau`,
  textPreviewsAriaLabel: `Abschnitt Textvorschau`,
  textVisibility: `Textsichtbarkeit`,
  textVisibilityAriaLabel: `Abschnitt Textsichtbarkeit`,
  visibleColumns: `Sichtbare Spalten`,
  visibleColumnsAria: `Sichtbare Spaltenliste`,
  visibleColumnsList: `Sichtbare Spalten`,
};
